import React from "react";
import PropTypes from "prop-types";
import { Col, FormGroup, InputGroup, Label, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import styled from "styled-components";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../../../../../components/CustomMultipleDateRange/CustomMultipleDateRange";

const EditBankModal = props => {
  const { isOpen, toggle, data, permissions } = props;
  const [date, setDate] = React.useState();

  let state = {
    isFormSubmit: false,
  };

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    if (errors?.length === 0) {
      let currentData = {};
      for (const [key, value] of Object.entries(params)) {
        if (value.length > 0) {
          currentData[key] = value;
        }
      }
      if (data?.id) {
        if (permissions["change_bankdetailsmodel"]) {
          props.updateBankDetails(data.id, currentData, props.userId);
        }
        toggle();
      } else {
        if (permissions["add_bankdetailsmodel"]) {
          currentData["user"] = props.userId;
          props.addBankDetails(currentData);
        }
        toggle();
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
      size="xl"
    >
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {Object.keys(data).length > 0 ? "Edit" : "Add"} bank information
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <ModalBody>
          <Row className="justify-content-center">
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="contract_number"
                    label="Contract number"
                    placeholder="Contract number..."
                    type="text"
                    value={data?.contract_number || ""}
                    validate={{
                      required: true,
                      minLength: {
                        value: 1,
                        errorMessage: "Min 3 words",
                      },
                      maxLength: {
                        value: 255,
                        errorMessage: "Max 255 words",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-3">
                  <PickerStyled>
                    <Label htmlFor="">Contract signatured date:</Label>
                    <CustomMultipleDateRange
                      placeholder="Select contract signatured date..."
                      defaultValue={data?.contract_signatured_date || ""}
                      name="contract_signatured_date"
                      datePickerType={"calendar"}
                      onChange={date => setDate(date)}
                      errorText="Signature date is required!"
                      required
                    />
                  </PickerStyled>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="company_name"
                    label="Company name"
                    placeholder="Company name..."
                    type="text"
                    value={data?.company_name || ""}
                    validate={{
                      required: true,
                      minLength: {
                        value: 1,
                        errorMessage: "Min 3 words",
                      },
                      maxLength: {
                        value: 255,
                        errorMessage: "Max 255 words",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="company_address"
                    label="Company address"
                    placeholder="Company address..."
                    type="text"
                    value={data?.company_address || ""}
                    validate={{
                      required: true,
                      minLength: {
                        value: 1,
                        errorMessage: "Min 3 words",
                      },
                      maxLength: {
                        value: 512,
                        errorMessage: "Max 512 words",
                      },
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <AvField
                    name="name_of_the_bank"
                    label="Name of the bank"
                    placeholder="Name of the bank..."
                    type="text"
                    value={data?.name_of_the_bank || ""}
                    validate={{
                      required: true,
                      minLength: {
                        value: 1,
                        errorMessage: "Min 3 words",
                      },
                      maxLength: {
                        value: 255,
                        errorMessage: "Max 255 words",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField
                    name="bank_swift_code"
                    label="Bank SWIFT / BIC"
                    placeholder="SWIFT / BIC code..."
                    type="text"
                    value={data?.bank_swift_code || ""}
                    validate={{
                      maxLength: {
                        value: 255,
                        errorMessage: "Max length 11",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <AvField
                    name="iban_code"
                    label="IBAN"
                    placeholder="IBAN code..."
                    type="text"
                    value={data?.iban_code || ""}
                    validate={{
                      maxLength: {
                        value: 34,
                        errorMessage: "Max length 34",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <AvField
                    name="bank_edrpou"
                    label="EDRPOU"
                    placeholder="EDRPOU..."
                    type="text"
                    value={data?.bank_edrpou || ""}
                    validate={{
                      maxLength: {
                        value: 1000,
                        errorMessage: "Max length 1000",
                      },
                    }}
                  />
                </div>
              </Col>
              <Col md={9}>
                <div className="mb-3">
                  <AvField
                    name="payment_description"
                    label="Payment description"
                    placeholder="Description..."
                    type="text"
                    value={data?.payment_description || ""}
                    validate={{
                      maxLength: {
                        value: 1000,
                        errorMessage: "Max length 1000",
                      },
                    }}
                  />
                </div>
              </Col>

            </Row>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end" style={{ marginRight: "15px" }}>
                {permissions["delete_bankdetailsmodel"] && (
                  <button
                    type="button"
                    className={`btn btn-danger save-user me-3 ${Object.keys(data).length > 0 ? "" : "d-none"
                      }`}
                    onClick={() => props.deleteDetails(true)}
                  >
                    Delete details
                  </button>
                )}
                <button type="submit" className="btn btn-success save-user">
                  Save changes
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

EditBankModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  permissions: PropTypes.any,
  updateBankDetails: PropTypes.func.isRequired,
  addBankDetails: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  deleteDetails: PropTypes.func,
};

export default EditBankModal;
